import React from 'react';
import { logo } from '../assets/svg/logo.js'
import { config } from '../helper/configVariable.js'

const Footer = () => {

  return (
    <div className="footer container d-flex justify-content-center flex-column align-items-center gap-3">
      <span>{logo.log_plus_text}</span>
      <span className='continue-text text-center'>
        Lorem ipsum dolor sit amet consectetur. Mattis amet velit mi nibh. Tincidunt scelerisque <br />
        sed nisi mus velit luctus congue habitant.
      </span>
      <div className='d-flex footer justify-content-evenly'>
        <span className='footer-text cursor-pointer' onClick={() => {
          window.open(config.TERMS_CONDITIONS_URL, "_blank");
        }}>Terms And Conditions</span>
        <span className='footer-text cursor-pointer' onClick={() => {
          window.open(config.PRIVACY_POLICY_URL, "_blank");
        }}>Privacy Policy</span>
        <span className='footer-text cursor-pointer'>Cookie Policy</span>
      </div>
    </div>

  );
};

export default Footer;
